<template>
  <div>
    <main-layout>
      <template v-if="iframeSrc">
        <div style="width: 100%; height: 93.4dvh">
          <iframe
            v-if="iframeSrc"
            ref="iframe"
            :key="key"
            sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
            :src="iframeSrc"
            :style="{ display: 'block', border: 'none', width: '100%', height: '100%' }"
          />
        </div>
      </template>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  data: function () {
    return {
      token: '',
      url: '',
      key: 1
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    }),
    iframeSrc() {
      if (!this.currentLang || !this.url || !this.token) return null

      const tempUrl = `${this.url}/${this.currentLang}/iframe-dashboard?tab=bot&token=${this.token}`

      // console.log('iframeSrc: ', tempUrl)

      return tempUrl
    },

    pageid: function () {
      if (!this.$store.state.selectedBot) {
        return null
      }
      return this.$store.state.selectedBot.pageid
    },

    questions: function () {
      if (this.welcome_intent && this.welcome_intent.q_val != '') {
        return this.welcome_intent.q_val.split(',')
      } else {
        return []
      }
    },
    answers: function () {
      return [[]]
    }
  },
  watch: {
    selectedBot(data) {
      const tempToken = data.page_custom_attributes_json.amaze_token || null
      const tempUrl = data.page_custom_attributes_json.amaze_cms_url

      this.token = tempToken
      this.url = tempUrl
      this.key = this.key++
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboardAmaze/DashboardAmaze.vue